export default __webpack_public_path__ + "static/media/arrowRight.ba42cb73.svg";